"use client"

import {createContext, useContext, useEffect, useMemo, useState} from 'react';
import {usePathname} from "next/navigation";

export const BlankContext = createContext(null);

export const BlankContextProvider = ({children}) => {

    const pathname = usePathname();
	const [is_blank, set_is_blank] = useState(false);

	useEffect(() => {
		if (is_blank) {
			set_is_blank(false)
		}
	}, [pathname]);

	const values = useMemo(() => ({
		is_blank,
		set_is_blank
	}), [is_blank]);


	return (
		<BlankContext.Provider value={{...values}}>
			{children}
		</BlankContext.Provider>
	);
};

export const useBlankContext = () => useContext(BlankContext)